import { render, staticRenderFns } from "./StudentCardStatusSelectbox.vue?vue&type=template&id=95c0fc86&"
import script from "./StudentCardStatusSelectbox.vue?vue&type=script&lang=js&"
export * from "./StudentCardStatusSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports